const BabyBeluga = [
	'[Verse 1]',
	'Baby Beluga in the deep blue sea',
	'Swim so wild and you swim so free',
	'Heaven above and the sea below',
	'And a little white whale on the go',
	'',
	'[Chorus]',
	'Baby Beluga, baby Beluga, is the water warm?',
	'Is your mama home with you so happy?',
	'',
	'[Verse 2]',
	'Way down yonder where the dolphins play',
	'Where you dive and splash all day',
	'Waves roll in and the waves roll out',
	'See the water squirting out of your spout',
	'',
	'[Chorus]',
	'Baby Beluga, oh, baby Beluga, sing your little song',
	"Sing for all your friends, we'll like to hear you",
	'',
	'[Verse 3]',
	"When it's dark you're home and fed",
	'Curl up snug in your water bed',
	'Moon is shining and the stars are out',
	'Good night, little whale, goodnight',
	'',
	'[Chorus]',
	"Baby Beluga, oh, baby Beluga, with tomorrow's sun",
	"Another day's begun, you'll soon be waking",
	'',
	'[Verse 4]',
	'Baby Beluga in the deep blue sea',
	'Swim so wild and you swim so free',
	'Heaven above and the sea below',
	'And a little white whale on the go',
	"You're just a little white whale on the go",
];

export default BabyBeluga;
